<template lang="pug">
    .cell-content-wrapper.l-flex-row.l-align-center
        svg-icon(v-if="isSharedAudience" name='share' size="small" title="shared audience")
</template>

<script>
import { isEmpty } from 'lodash'

export default {
    props: {
        fullData: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        isSharedAudience() {
            return !isEmpty(this.fullData.sharedAudience)
        }
    }
}
</script>
